import { SplashScreen } from '@capacitor/splash-screen';
import { useEffect } from 'react';

import { isNativePlatform } from '@/shared/utils/platform';

/**
 * Hides the native splash screen when React has mounted.
 * Only runs on native platforms (iOS/Android), no-op on web.
 */
export function useSplashScreen() {
  useEffect(() => {
    if (isNativePlatform()) {
      void SplashScreen.hide({ fadeOutDuration: 300 });
    }
  }, []);
}
